import { propsEqualityFn } from '@src/utils/object-utils/object-utils';
import { memo } from 'react';

interface ContentModScoreProps {
    moderationContent: string;
    moderationScore: number;
}

const ContentModScore: React.FC<ContentModScoreProps> = props => {
    const { moderationContent, moderationScore } = props;
    const score = moderationScore;
    let message = '';
    let messageClassName = '';

    if (score === 0) {
        return null;
    }
    if (score > 0 && score <= 50) {
        message = `Moderation Score: ${score}%`;
        messageClassName = 'text-yellow-500';
    } else {
        message = `Moderation Score: ${score}%`;
        messageClassName = 'text-red-500';
    }

    return (
        <div className="mt-1 text-xs">
            <span className={messageClassName}>{message}</span>
            <span className="block text-xs text-gray-500">{moderationContent}</span>
        </div>
    );
};

export default memo(ContentModScore, propsEqualityFn);
